// @ts-nocheck
export const URL = process.env.PUBLIC_URL + '/assets/characters/character_witch.gltf'

export const useModel = (): GLTFResult => {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  Object.values(nodes).forEach(n => n.traverse(ch => (ch.type === 'Mesh' ? (ch.castShadow = true) : null)))
  return { nodes, materials }
}
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    Cube5268: THREE.Mesh;
    Cube5268_1: THREE.Mesh;
    Cube5268_2: THREE.Mesh;
    Cube5268_3: THREE.Mesh;
    Cube040: THREE.Mesh;
    Cube040_1: THREE.Mesh;
    Cube039: THREE.Mesh;
    Cube039_1: THREE.Mesh;
    Cube001: THREE.Mesh;
    Cube001_1: THREE.Mesh;
    Cube001_2: THREE.Mesh;
    Cube004: THREE.Mesh;
    Cube004_1: THREE.Mesh;
    Cube004_2: THREE.Mesh;
  };
  materials: {
    Purple: THREE.MeshStandardMaterial;
    Yellow: THREE.MeshStandardMaterial;
    Black: THREE.MeshStandardMaterial;
    GreenLight: THREE.MeshStandardMaterial;
    Green: THREE.MeshStandardMaterial;
  };
};

export function Model(props: JSX.IntrinsicElements["group"]) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult;
  return (
    <group {...props} dispose={null}>
      <group name="character_witch" userData={{ name: "character_witch" }}>
        <mesh
          name="Cube5268"
          castShadow
          receiveShadow
          geometry={nodes.Cube5268.geometry}
          material={materials.Purple}
        />
        <mesh
          name="Cube5268_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube5268_1.geometry}
          material={materials.Yellow}
        />
        <mesh
          name="Cube5268_2"
          castShadow
          receiveShadow
          geometry={nodes.Cube5268_2.geometry}
          material={materials.Black}
        />
        <mesh
          name="Cube5268_3"
          castShadow
          receiveShadow
          geometry={nodes.Cube5268_3.geometry}
          material={materials.GreenLight}
        />
        <group
          name="character_witchArmLeft"
          position={[0.2, 0.63, 0]}
          userData={{ name: "character_witchArmLeft" }}
        >
          <mesh
            name="Cube040"
            castShadow
            receiveShadow
            geometry={nodes.Cube040.geometry}
            material={materials.Purple}
          />
          <mesh
            name="Cube040_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube040_1.geometry}
            material={materials.GreenLight}
          />
        </group>
        <group
          name="character_witchArmRight"
          position={[-0.2, 0.63, 0]}
          userData={{ name: "character_witchArmRight" }}
        >
          <mesh
            name="Cube039"
            castShadow
            receiveShadow
            geometry={nodes.Cube039.geometry}
            material={materials.Purple}
          />
          <mesh
            name="Cube039_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube039_1.geometry}
            material={materials.GreenLight}
          />
        </group>
        <group
          name="character_witchHead"
          position={[0, 0.7, 0]}
          userData={{ name: "character_witchHead" }}
        >
          <mesh
            name="Cube001"
            castShadow
            receiveShadow
            geometry={nodes.Cube001.geometry}
            material={materials.Black}
          />
          <mesh
            name="Cube001_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_1.geometry}
            material={materials.GreenLight}
          />
          <mesh
            name="Cube001_2"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_2.geometry}
            material={materials.Green}
          />
          <group
            name="character_witchHat"
            position={[0, 0.77, -0.07]}
            rotation={[-0.26, 0, 0]}
            userData={{ name: "character_witchHat" }}
          >
            <mesh
              name="Cube004"
              castShadow
              receiveShadow
              geometry={nodes.Cube004.geometry}
              material={materials.Purple}
            />
            <mesh
              name="Cube004_1"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_1.geometry}
              material={materials.Black}
            />
            <mesh
              name="Cube004_2"
              castShadow
              receiveShadow
              geometry={nodes.Cube004_2.geometry}
              material={materials.Yellow}
            />
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload(URL);
